
import ClipImg from "./imgClip.js";
export default ClipImg
